import { Box, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormattedChart from "./components/FormattedChart";

const Charts = (props) => {
  // const data = useSelector((state) => state.sensors.data.ocpAvgsData);
  // console.log("props.data:", props.data);
  // console.log("Charts rerender!");
  // console.log(data[0]?.data);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const getDataset = data => {};

  const aggregated = props.data.reduce((acc, curr) => {
    curr.data.forEach((point, index) => {
      // if this time slot hasn't been initialized yet, create it
      if (!acc[index]) {
        acc[index] = { dateTime: point.dateTime, total: 0, count: 0 };
      }
      acc[index].total += point.ocpAvg;
      acc[index].count += 1;
    });
    return acc;
  }, []);

  const averagedData = aggregated.map((item) => ({
    dateTime: item.dateTime,
    ocpAvg: item.total / item.count,
  }));

  const newObject = {
    data: averagedData,
    // date range from first to last object in data
    date: `selected dates average`,
  };

  const dataSets = [newObject, ...props.data];

  // console.log("avg obj:", newObject);

  return props.data[0]?.data !== null ? (
    <FormattedChart
      title={"Occupancy Averages"}
      datasets={dataSets}
      isRange={false}
      sensorId={""}
    />
  ) : (
    <Box
      sx={{ display: "flex", justifyContent: "center", paddingTop: "20rem" }}
    >
      <Typography>No sensors has been selected</Typography>
    </Box>
  );
};

export default Charts;
